import { render } from "./SkyInputChips.vue?vue&type=template&id=04f05c8b"
import script from "./SkyInputChips.vue?vue&type=script&lang=js"
export * from "./SkyInputChips.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__